module.exports = __webpack_public_path__ + "img/DE04232.c8e1db06.png";